import React, { useState } from "react";
import { Image, Card, Button, Row, Col } from "react-bootstrap";

import styled from "styled-components";
import { handleOnImg404 } from "../../utils";

const CustomHorizontalCard = styled(Card)`
  width: 27rem;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  border: 0;
`;

const CustomImgCard = styled(Card.Img)`
  object-fit: contain;
  height: 100%;
`;

const CustomCardTitle = styled(Card.Title)`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 1.563rem;
`;

const CustomCardText = styled(Card.Text)`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 1.563rem;
  margin-bottom: 0.25rem;
`;

const ImageWrapper = styled.div`
  height: ${({ height }) => height || "9.9rem"};
`;

// Componente genérico para cartas que tienen la imagen situada a la izquierda y el texto a la derecha
//  Recibe:
// title --> El título de la carta
// cardImage --> La img de la carta, src o fichero
// body --> un array de objetos para mostrar el texto de la carta, cada item del array será un objeto con un value y una imagen opcional a colocar
//

const HorizontalCard = ({ title, cardImage, body = [], imgOnError, heightPhoto, ciudad='', destino='',  ...props }) => {
  return (
    <CustomHorizontalCard {...props}>
      <Row noGutters>
        <Col md={4}>
          <ImageWrapper height={heightPhoto}>
            <CustomImgCard src={cardImage} onError={(e) => handleOnImg404(e, imgOnError)} />
          </ImageWrapper>
        </Col>
        <Col md={8}>
          <Card.Body>
            <CustomCardTitle title={title}>{title}</CustomCardTitle>
            {ciudad !== '' && <CustomCardText title={ciudad}>{ciudad}</CustomCardText>}
            {destino !== '' && <small><CustomCardText title={destino}>{destino}</CustomCardText></small>}
            {body.map((textItem, index) => {
              let img = textItem.img ? <Image className={"align-top mr-1"} title={textItem.img.title} src={textItem.img.url} height={textItem.img.size} /> : "";
              return (
                <CustomCardText key={index} title={textItem.value} >
                  {img}
                  {textItem.value}
                </CustomCardText>
              );
            })}
            {/* {buttons} */}
          </Card.Body>
        </Col>
      </Row>
    </CustomHorizontalCard >
  );
};

export default HorizontalCard;
